import { render, staticRenderFns } from "./ClassifyDetails.vue?vue&type=template&id=5391db1a&scoped=true&"
import script from "./ClassifyDetails.vue?vue&type=script&lang=js&"
export * from "./ClassifyDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyDetails.vue?vue&type=style&index=0&id=5391db1a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5391db1a",
  null
  
)

export default component.exports